export default __webpack_public_path__ + "static/media/photo--lg--blitz-5.57466e1a.jpg";